<section class="bmc-authorization">
    <div class="bmc-authorization__header">
      <div class="bmc-authorization__content">
        <p>{{'AUTHORIZATION.DESCRIPTION' | translate}}</p>
        <div *ngIf="!disableAuthorizationReport" class="bmc-authorization__download-message">
          <bzg-button-secondary 
          class="bmc-sync-data__button" 
          [icon]="'icon-download'" 
          (click)="downloadReport()" 
          [disabled]="isDownloading"
          [ngClass]="{'button_downloading': isDownloading}">
          <bz-loading *ngIf="isDownloading" [size]="'s'"></bz-loading>
          {{ "AUTHORIZATION.DOWNLOAD_REPORT_MESSAGE" | translate }}
        </bzg-button-secondary>
        </div>
      </div>
    </div>
    <div class="bmc-authorization__tree-main">
      <div class="bmc-authorization__tree-panel" id="panel-tree">
        <div class="tree-container">
          <h5 class="bz-font-weight--semibold">{{ 'AUTHORIZATION.CONFIG_TITLE' | translate }}</h5>
          <bz-tree [tree]="_treeParent" (clickNodeEvent)="onChildClick($event)" [currentId]="currentValue" [currentParentId]="currentParentId"></bz-tree>
        </div>
      </div>
      <div class="bmc-authorization__tree-detail" >
        <div class="bmc-authorization__placeholder" *ngIf="!isLoadingNodes && !isLoadingData && !showDetail && !isEmpty">
          <p class="bmc-authorization__placeholder__text">{{'AUTHORIZATION.SELECT_COMPONENT' | translate}}</p>
        </div>
        <div *ngIf="isLoadingData" class="bz-env-loading">
          <bz-loading [message]="'GLOBAL.LOADING_DATA'"></bz-loading>
        </div>
        <div *ngIf="isLoadingNodes" class="bz-env-loading">
          <bz-loading [message]="'AUTHORIZATION.LOADING_NODES'"></bz-loading>
        </div>
        <div *ngIf="isEmpty">
          <div class="bmc-authorization__image">
            <img src="assets/img/bz-not-found.png">
            <p>{{ 'AUTHORIZATION.WHITHOUT_COMPONENTS' | translate }}</p>
          </div>
        </div>
        <authorization-detail #authDetailComponent *ngIf="showDetail"
          [detailData]="authorizationDetail"
          [nodeId]="nodeId"
          [detailName]="detailName"
          [authorizationType]="currentAuthorizationType"
          [parameters]="usersRolesStakeholders" (onCancelChanges)="onChildClick({isDetail: true, value: 'cancel'})">
        </authorization-detail>
      </div>
    </div>
</section>

